import HeaderIconButton from "./HeaderIconButton";
import { Icon } from "../ui/Icon";
import { getIframeDimensions } from "@/app/[tenantId]/[messengerId]/[hostConfig]/lib/client/utils/getIframeDimensions";
import clsx from "clsx";
import { useLauncherStore } from "@/app/[tenantId]/[messengerId]/[hostConfig]/lib/client/contexts/LauncherStoreContext";
import { useShallow } from "zustand/react/shallow";
import { useLauncherContext } from "@/app/[tenantId]/[messengerId]/[hostConfig]/lib/client/contexts/LauncherContext";

export default function ErrorCloseButton({ messengerId }: { messengerId?: string }) {
  const { showLauncherButton, setIsOpen, config } = useLauncherStore(
    useShallow((state) => ({
      showLauncherButton: state.showLauncherButton,
      setIsOpen: state.setIsOpen,
      config: state.config,
    })),
  );
  const { connection } = useLauncherContext();

  const offsetBottom = config?.settings?.displaySettings.placement?.offsetBottom ?? 0;
  const offsetSide = config?.settings?.displaySettings.placement?.offsetSide ?? 0;

  return (
    <HeaderIconButton
      onClick={async () => {
        if (!messengerId) return;

        setIsOpen(false);

        // Allow the animation to complete before closing the app
        setTimeout(async () => {
          if (!connection?.current) return;
          const parentApi = await connection.current.promise;
          const parentViewDimensions = await parentApi.getViewDimensions(messengerId);
          const data = getIframeDimensions({
            isOpen: false,
            showLauncherButton,
            offsetBottom,
            offsetSide,
            parentViewDimensions,
          });

          parentApi.close(messengerId, data);
        }, 300);
      }}
      className={clsx("p-0")}
    >
      <Icon icon="dazzle-linear-xmark" size="text-2xl" />
    </HeaderIconButton>
  );
}
